import React, { useState } from 'react';
import './Navbar.css';
import logo from '../../assets/turanlogo.JPG'; // Logoyu assets içinden çekiyoruz

function Navbar() {
  const [isMobile, setIsMobile] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <a href="#anasayfa">
          <img src={logo} alt="Turan Hoca Logo" />
        </a>
      </div>
      
      <ul 
        className={isMobile ? "nav-links-mobile" : "nav-links"} 
        onClick={() => setIsMobile(false)}
      >
        <li><a href="#anasayfa">Anasayfa</a></li>
        <li><a href="#hakkinda">Hakkında</a></li>
        <li><a href="#hizmetler">Hizmetler</a></li>
        <li><a href="#iletisim" className="nav-contact-btn">İletişim</a></li>
      </ul>

      <button 
        className="mobile-menu-icon" 
        onClick={() => setIsMobile(!isMobile)}
      >
        {isMobile ? <span>&#10005;</span> : <span>&#9776;</span>}
      </button>
    </nav>
  );
}

export default Navbar;